import { Component, Input, OnInit } from '@angular/core';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import {
  LightspeedStaffUser,
  OrganizationConfigService,
} from '../../../../../../../services/organization-config/organization-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationConfig } from '../../../../../../../models/organization-config';


@Component({
  selector: 'app-set-capitan-lightspeed-user-modal',
  templateUrl: './set-capitan-lightspeed-user-modal.component.html',
  styleUrls: ['./set-capitan-lightspeed-user-modal.component.css']
})
export class SetCapitanLightspeedUserModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public orgConfig: OrganizationConfig = null;
  public lightspeedUserList: LightspeedStaffUser[];
  public selectedUser: LightspeedStaffUser = null;

  public loadingLightspeedUsers = true;
  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.orgConfig = this.orgConfigService.getOrganizationConfig();
    if (this.orgConfig === null) {
      this.orgConfigService
        .loadOrganizationConfig()
        .then(() => {
          this.orgConfig = this.orgConfigService.getOrganizationConfig();
        });
    }

    this.loadLightspeedUsers();
  }

  public handleSubmit() {
    if (this.loadingLightspeedUsers || this.loadingSave) { return; }
    if (this.selectedUser === null) { return; }

    this.loadingSave = true;
    this.errorMessage = '';

    this.orgConfigService
      .updateOrgConfig(
        {
          lightspeed_capitan_user_id: this.selectedUser.user_id,
          lightspeed_capitan_user_username: this.selectedUser.username,
          lightspeed_capitan_user_display_name: this.selectedUser.display_name,
        }
      )
      .then(() => {
        this.savedCallback({
          text: 'Capitan Lightspeed user updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

  public isLoadingInitial() {
    return (
      (this.orgConfig === null) ||
      this.loadingLightspeedUsers
    )
  }

  private loadLightspeedUsers() {
    this.loadingLightspeedUsers = true;

    this.orgConfigService
      .getLightspeedStaffUsers()
      .then(response => {
        this.lightspeedUserList = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingLightspeedUsers = false; });
  }
}
